export default "__VITE_PUBLIC_ASSET__119eb1bb__"